import { getIntegrationKey } from '../routing/getIntegrationKey';
export const isIntegration = integration => {
  const integrationKey = getIntegrationKey();
  return integrationKey === integration;
};